import React from "react";

// Component
import DashboardPopOver from "../../../component/DashboardPopOver";
import { useSelector, useDispatch } from "react-redux";
import { addToMyDashboard, deleteWidgets } from "../../../redux/actions/analytics";

function HorizontalStackedBar({
  id,
  title,
  menu,
  value,
  isDisable,
  setUpdate,
  update,
  tab
}) {
  const dispatch = useDispatch();

  // Add To My Dashboard
  const handleAddToMyDashboard = () => {
    const request = {
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1)
      },
      payload: {
        analytic_widget_id: id.analytic_widget_id,
      },
    };

    dispatch(addToMyDashboard(request));
  };

  // Delete Widget
  const handleDeleteWidgets = () => {
    const request = {
      dashboard_widget_id: id.analytic_dashboard_id,
      onError: (error) => {
        console.log(error)
      },
      onSuccess: () => {
        setUpdate(update + 1);
      }
    }

    dispatch(deleteWidgets(request))
  }
  

  return (
    <div className="w-full h-full">
      <div className="absolute top-1 right-2 text-base text-[#7D8490]">
        <DashboardPopOver
          menus={menu}
          handleOnClick={() => tab ? handleDeleteWidgets() : handleAddToMyDashboard()}
          isDisable={isDisable}
        />
      </div>

      <div className="h-full w-full space-y-4">
        <h2 className="text-sm font-semibold text-[#313439] leading-5">
          {title}
        </h2>
        <div className="w-full h-[20px] rounded flex">
          <div
            className={`h-full rounded-s bg-[--bg-color-500] px-1 flex items-center justify-end relative`}
            style={{
              width:
                Number(value?.user) > 17 ? Number(value.user) + "%" : "25%",
            }}
          >
            <h3 className="text-left text-[10px] text-[#fff] font-normal">
              {value?.user ? value.user : 0}%
            </h3>
            <div className="text-[10px] font-normal text-[#535860] leading-5 absolute -bottom-5 left-0">
              Internal Users
            </div>
          </div>
          <div
            className={`h-full bg-[--bg-color-200] px-1 flex items-center justify-end relative`}
            style={{
              width:
                Number(value?.collaborator) > 17
                  ? Number(value.collaborator) + "%"
                  : "25%",
            }}
          >
            <h3 className="text-left text-[10px] text-[#fff] font-normal">
              {value?.collaborator ? value.collaborator : 0}%
            </h3>
            <div
              className={`text-[10px] font-normal text-[#535860] leading-5 absolute -bottom-5 ${
                Number(value?.collaborator) > 17 ? "left-0" : "right-1"
              }`}
            >
              Collaborators
            </div>
          </div>
          <div
            className={` h-full rounded-e bg-[--bg-color-300] px-1 flex justify-end items-center relative`}
            style={{
              width:
                Number(value?.customer) > 17
                  ? Number(value?.customer) + "%"
                  : "25%",
            }}
          >
            <h3 className="text-left text-[10px] text-[#fff] font-normal">
              {value?.customer ? value.customer : 0}%
            </h3>
            <div className="text-[10px] font-normal text-[#535860] leading-5 absolute -bottom-5 left-0">
              Customers
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HorizontalStackedBar;
